import { cn } from '@/lib/utils';

import { pricingCardContainerStyles } from './styles';

import { SvgIcon } from '@/components/SvgIcon';
import { outlineClasses } from '@/blocks/PricingCards/PricingCard';
import PricingCardCTA from '@/blocks/PricingCards/PricingCardCTA';
import { passButtonIcons } from '@/components/atoms/Button/utils';
import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/components/atoms/RichTextField/RichTextFieldStrapi';
import { applyToAllRTFVariants } from '@/components/atoms/RichTextField/utils';
import iconContactSalesSrc from '~/icons/message-chat-circle.svg';

export type ContactSalesProps = {
  heading?: RichTextFieldStrapiProps;
  description?: RichTextFieldStrapiProps;
  button: Pick<
    LinkButtonStrapiProps,
    'text' | 'variant' | 'color' | 'url' | 'leftSection' | 'rightSection'
  >;
  outlineColor?: 'grey' | 'brand' | 'gradient';
};

export default function ContactSales({
  heading,
  description,
  button,
  outlineColor = 'gradient',
}: ContactSalesProps) {
  const trackId = 'ContactUs-pricing-cards';

  const resolvedIcons = passButtonIcons({
    ...button,
    fallbackIcon: {
      leftSection: <SvgIcon src={iconContactSalesSrc} className='h-5 w-5' />,
    },
  });

  return (
    <div
      data-tracker-component='contact-card'
      className={cn(
        pricingCardContainerStyles,
        outlineColor && outlineClasses[outlineColor],
        'h-auto justify-between self-stretch dark:bg-gray-dark-950'
      )}
    >
      <div className='mt-6'>
        {heading && (
          <RichTextFieldStrapi
            block={heading}
            classNames={applyToAllRTFVariants(
              'text-h2 text-center font-serif dark:text-base-dark-white'
            )}
          />
        )}

        {description && (
          <RichTextFieldStrapi
            block={description}
            classNames={applyToAllRTFVariants(
              cn(
                'text-body-m text-center dark:text-gray-dark-400',
                heading && 'mt-4'
              )
            )}
          />
        )}
      </div>

      <PricingCardCTA
        url={button.url}
        text={button?.text || ''}
        variant={button.variant || 'filled'}
        color={button.color || 'secondary'}
        trackEventName='contact_sales_cta_click'
        trackId={trackId}
        className='mt-14'
        dataTrackerComponent='contact-sales'
        leftSection={resolvedIcons.leftSection}
        rightSection={resolvedIcons.rightSection}
      />
    </div>
  );
}
